module.exports = __webpack_public_path__ + "static/img/twin-highway-1.2791db12.png";